const isProd = () => window.location.hostname.includes("musik.digital");

export default isProd;
